export enum JobTypeEnum {
    REPORT = 'report',
    STATISTICS_CACHE_WARMING = 'statistics_cache_warming',
}
